// @flow

export const setDocumentTitle = (
  subtitle: string,
  title: string | null = 'Idealist'
) => {
  if (typeof document === 'object') {
    document.title = `${subtitle}${title ? ` - ${title}` : ''}`;
    const metaOg = document.querySelector('meta[property="og:title"]');
    if (metaOg) {
      metaOg.setAttribute('content', subtitle);
    }
  }
};
